import { ClassificationLevel } from '@sonar-software/sonar-core';
import { ClassificationTag } from '@ui/tags';
import React from 'react';
import { When } from 'react-if';

export interface AuditTrailActionProps {
	action: string;
	classification?: ClassificationLevel;
}

export const AuditTrailAction: React.FC<AuditTrailActionProps> = ({ action, classification }) =>
	<span className='audit-trail-action'>
		<When condition={ classification }>
			<ClassificationTag classification={ classification } />
		</When>
		{ action }
	</span>;
